import React from 'react';
import { Typography, Button, Paper } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { InvestigationPlan } from './types';

interface NextBestActionProps {
  plan: InvestigationPlan;
  onActionClick: () => void;
}

export const NextBestAction: React.FC<NextBestActionProps> = ({
  plan,
  onActionClick,
}) => {
  if (!plan.nextBestAction) return null;

  const { title, description, actionType } = plan.nextBestAction;

  const getActionButton = () => {
    switch (actionType) {
      case 'schedule':
        return (
          <Button
            variant="contained"
            startIcon={<CalendarTodayIcon />}
            onClick={onActionClick}
          >
            Schedule via Outlook
          </Button>
        );
      default:
        return (
          <Button variant="contained" onClick={onActionClick}>
            Take Action
          </Button>
        );
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mb: 3,
        bgcolor: 'background.default',
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Typography
        variant="overline"
        fontWeight={600}
        color="text.secondary"
        sx={{ display: 'block', mb: 1 }}
      >
        Next Best Action
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
        {title}
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>

      {getActionButton()}
    </Paper>
  );
};
